var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO_-_FACEBOOK",
    "data-name": "LOGO - FACEBOOK",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.978,
    height: 15.316,
    viewBox: "0 0 7.978 15.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Facebook_1_",
    d: "M224.431,182.616v-7h2.333l.339-2.709h-2.709v-1.731c0-.79.226-1.317,1.355-1.317h1.43v-2.446a17.736,17.736,0,0,0-2.107-.113,3.293,3.293,0,0,0-3.5,3.613v1.994H219.2v2.709h2.371v7h2.86Z",
    transform: "translate(-219.2 -167.3)",
    fill: "#3c3c3b",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.76a994bd4853aee3c7e309690b4190ca.svg";
export { ForwardRef as ReactComponent };